var RanklistCompetitorPointsType;
(function (RanklistCompetitorPointsType) {
    RanklistCompetitorPointsType[RanklistCompetitorPointsType["NationalChampionship"] = 0] = "NationalChampionship";
    RanklistCompetitorPointsType[RanklistCompetitorPointsType["LeagueCompetition"] = 1] = "LeagueCompetition";
    RanklistCompetitorPointsType[RanklistCompetitorPointsType["WDSFCompetition"] = 2] = "WDSFCompetition";
    RanklistCompetitorPointsType[RanklistCompetitorPointsType["WDSFRanklist"] = 3] = "WDSFRanklist";
    RanklistCompetitorPointsType[RanklistCompetitorPointsType["G_Cup"] = 4] = "G_Cup";
})(RanklistCompetitorPointsType || (RanklistCompetitorPointsType = {}));
var RanklistType;
(function (RanklistType) {
    RanklistType[RanklistType["Continuous"] = 0] = "Continuous";
    RanklistType[RanklistType["Nomination"] = 1] = "Nomination";
    RanklistType[RanklistType["Championship"] = 2] = "Championship";
})(RanklistType || (RanklistType = {}));
var RanklistStatus;
(function (RanklistStatus) {
    RanklistStatus[RanklistStatus["Private"] = 0] = "Private";
    RanklistStatus[RanklistStatus["Public"] = 1] = "Public";
})(RanklistStatus || (RanklistStatus = {}));
var ranklistTypeToStringShort = function (val) {
    if (val === RanklistType.Continuous) {
        return "průběžný";
    }
    if (val === RanklistType.Nomination) {
        return "nom. - NRT";
    }
    if (val === RanklistType.Championship) {
        return "nom. - MČR";
    }
    return "";
};
export { RanklistCompetitorPointsType, RanklistType, RanklistStatus, ranklistTypeToStringShort, };
